export const getMetaContent = (name) => {
  const metas = document.getElementsByTagName("meta");

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute("name") == name) {
      return metas[i].getAttribute("content");
    }
  }

  return "";
};

// squashes all flash messages into one big string.
export const indiscriminatelyCombineFlashMessages = (messages) => {
  const arrayMessages = [];
  for (const key in messages) {
    if (messages.hasOwnProperty(key)) {
      arrayMessages.push(messages[key]);
    }
  }

  return arrayMessages.join("\n");
};
